import React, { useEffect, useState } from "react";
import styles from "../../../../layout/Auth/Auth.module.scss";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import logo from "../../../../Assets/images/logo.png";
import Select from "react-select";
import CommonInput from "../../../PublicPages/Page/CommonInput";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import PhoneInput from "react-phone-input-2";
import AddressInput from "../../../../components/Common/address";
import config from "../../../../config";

import { VENDOR_STRIPE_CONNECT, VENDOR_STRIPE_CONNECT_DETAIL, VENDOR_SIGNUP } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import { catchAsync } from "../../../../utilities/utilies";
import fileUploader from "../../../../utilities/fileUploader";

const requiredString = (name) =>
	z
		.string()
		.trim()
		.min(1, { message: `${name} is required` });

const getSchema = () => {
	return z.object({
		businessEmail: z
			.string()
			.email({ message: "Invalid email format" })
			.nonempty("Email is required"),
		businessName: requiredString("Name"),
		mobileNumber: requiredString("Mobile number"),
		countryCode: requiredString("Country Code"),
		storeLocation: requiredString("Store Location"),
		city: requiredString("City"),
		state: requiredString("State / Province"),
		pincode: requiredString("Postal / ZIP Code"),
		country: requiredString("Country"),
		password: requiredString("Password"),
		cnfPassword: requiredString("Confirm Password"),

	});
};

const VendorSignup = () => {
	const schema = getSchema();
	const [isStripeConnected, setStripeConnected] = useState(false)
	const [stripeConnectToggle, setstripeConnectToggle] = useState(false)
	const vendorSignupFormdata = localStorage.getItem("vendorSignupFormdata") ? JSON.parse(localStorage.getItem("vendorSignupFormdata")) : null;
	const [stripeAccountDetail, setStripeAccountDetail] = useState(null)
	const [images, setImages] = useState([]);
	const [imageUploadLoader, setImageUploadLoader] = useState(false);
	const [documents, setDocuments] = useState([]);
	const [documentUploadLoader, setDocumentUploadLoader] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		watch,
		getValues,
		trigger,
	} = useForm({
		resolver: zodResolver(schema),

		defaultValues: {},
	});

	const onSubmit = async (data) => {
		data = {
			...data,
			storeLocationCoordinates: vendorSignupFormdata?.storeLocationCoordinates,
			stripeAccountId: vendorSignupFormdata?.stripeAccountId,
			stripeConnectStatus: true,
			profileImage: vendorSignupFormdata?.profileImage,
			documentsList: vendorSignupFormdata?.documentsList,
			bankDetails: {
				routingNumber: stripeAccountDetail?.external_accounts?.data?.[0]?.routing_number,
				accountNumber: stripeAccountDetail?.external_accounts?.data?.[0]?.last4,
				accountHolderName: `${stripeAccountDetail?.individual?.first_name} ${stripeAccountDetail?.individual?.last_name}`,
				bankName: stripeAccountDetail?.external_accounts?.data?.[0]?.bank_name
			}
		}
		let response = await VENDOR_SIGNUP(data);
		if (response?.data?._id) {
			toast.success("Vendor Signup Sucessfully");
			localStorage.removeItem("vendorSignupFormdata");
			setStripeConnected(false)
			setStripeAccountDetail(null)
			// location.reload();
			setShowModal(true)
		} else {
			toast.error(response?.data?.message);
		}

	};

	const onLatLongGet = (latLong) => {
		setValue("storeLocationCoordinates", latLong, { shouldValidate: true });
	};

	useEffect(() => {
		fetchStripeConnectDetail()
	}, [])

	useEffect(() => {
		if (isStripeConnected && vendorSignupFormdata) {
			setValue("businessName", vendorSignupFormdata?.businessName)
			setValue("businessEmail", vendorSignupFormdata?.businessEmail)
			setValue("countryCode", vendorSignupFormdata?.countryCode)
			setValue("mobileNumber", vendorSignupFormdata?.mobileNumber)
			setValue("password", vendorSignupFormdata?.password)
			setValue("cnfPassword", vendorSignupFormdata?.cnfPassword)
			setValue("storeLocation", vendorSignupFormdata?.storeLocation)
			setValue("city", vendorSignupFormdata?.city)
			setValue("state", vendorSignupFormdata?.state)
			setValue("pincode", vendorSignupFormdata?.pincode)
			setValue("country", vendorSignupFormdata?.country)
			setValue("storeLocationCoordinates", vendorSignupFormdata?.storeLocationCoordinates)
			setValue("stripeAccountId", vendorSignupFormdata?.stripeAccountId)
			setValue("stripeConnectStatus", true)
			setValue("profileImage", vendorSignupFormdata?.profileImage)
			setValue("documentsList", vendorSignupFormdata?.documentsList)
			setImages([vendorSignupFormdata?.profileImage])
			setDocuments([vendorSignupFormdata?.documentsList[0]?.image])
		} else {
			setStripeConnected(false)
			setStripeAccountDetail(null)
		}
	}, [isStripeConnected])

	const fetchStripeConnectDetail = async () => {
		if (vendorSignupFormdata?.stripeAccountId) {
			let response = await VENDOR_STRIPE_CONNECT_DETAIL({}, `?stripeAccountId=${vendorSignupFormdata?.stripeAccountId}`)
			if (response?.data) {
				setStripeAccountDetail(response?.data);
				setStripeConnected(true);
			} else {
				toast.error("Failed to connect stripe");
			}
		} else {
			setStripeConnected(false)
			setStripeAccountDetail(null)
		}
	}

	const handleStripeConnect = async (e) => {
		setstripeConnectToggle(e.target.checked);
		let businessName = watch("businessName");
		let businessEmail = watch("businessEmail");
		let countryCode = watch("countryCode");
		let mobileNumber = watch("mobileNumber");
		let storeLocation = watch("storeLocation");
		let city = watch("city");
		let state = watch("state");
		let pincode = watch("pincode");
		let country = watch("country");
		let storeLocationCoordinates = watch("storeLocationCoordinates")
		let password = watch("password");
		let cnfPassword = watch("cnfPassword");

		if (businessEmail && images.length && documents.length && e.target.checked) {
			localStorage.removeItem("vendorSignupFormdata");

			const response = await VENDOR_STRIPE_CONNECT({ businessEmail, country, returnUrl: `${config.baseURL}/vendor/signup`, refreshUrl: `${config.baseURL}/vendor/signup` });
			if (response?.data?.data?.url) {
				localStorage.setItem("vendorSignupFormdata", JSON.stringify({ businessName, businessEmail, countryCode, mobileNumber, storeLocation, city, state, pincode, country, stripeAccountId: response?.data?.data?.accountId, storeLocationCoordinates: storeLocationCoordinates, profileImage: images[0], documentsList: [{ image: documents[0], date: null, type: "proof" }], password, cnfPassword }))

				window.location.href = response?.data?.data?.url;
			} else {
				toast.error("Failed to connect stripe");
			}

		} else if (businessEmail && images.length && documents.length && isStripeConnected) {

			localStorage.removeItem("vendorSignupFormdata");
			setStripeConnected(false)
			setStripeAccountDetail(null)
			toast.error("Stripe disconnect successfully");
		} else {
			toast.error("Please fill all fields first");
			setstripeConnectToggle(false);
		}
	}


	const imageUploadHandler = catchAsync(async (e) => {
		setImageUploadLoader(true);
		const url = await fileUploader(e?.target?.files[0]);

		if (!url) {
			setImageUploadLoader(false);
			return;
		}

		setImages([url]);
		setImageUploadLoader(false);
	});

	const removeImageHandler = (value) => {
		setImages((p) => {
			const arr = [...p];
			const index = arr.findIndex((item) => item === value);

			if (index !== -1) {
				arr.splice(index, 1);
			}

			return arr;
		});
	};

	const documentUploadHandler = catchAsync(async (e) => {
		setDocumentUploadLoader(true);
		const url = await fileUploader(e?.target?.files[0]);

		if (!url) {
			setDocumentUploadLoader(false);
			return;
		}

		setDocuments([url]);
		setDocumentUploadLoader(false);
	});

	const removeDocumentHandler = (value) => {
		setDocuments((p) => {
			const arr = [...p];
			const index = arr.findIndex((item) => item === value);

			if (index !== -1) {
				arr.splice(index, 1);
			}

			return arr;
		});
	};

	const handleClose = () => {
		setShowModal(false)
		localStorage.removeItem("vendorSignupFormdata");
		location.reload()
	}
	return (
		<>

			<section
				className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
				style={{ zIndex: "9" }}
			>
				<Container className="">
					<Row className="justify-content-center">
						<Col lg="11" className="my-2">
							<div
								className={`${styles.formWrpper} formWrpper `}
								style={{ background: "#FBFBFB", height: "90vh" }}
							>
								<Row className="h-100">
									<Col
										lg="6"
										className={`${styles.imgWrpper} ${styles.logo}  d-none d-lg-flex align-items-center justify-content-center h-100`}
									>
										<img
											src={logo}
											alt=""
											className="img-fluid object-contain"
										/>
									</Col>
									<Col lg="6" className="my-2 py-4 h-100">
										<div className="formInner overflow-auto px-lg-5 px-3 position-relative h-100">
											<Form onSubmit={handleSubmit(onSubmit)}>
												<Row>
													<Col md="12" className="my-2">
														<label htmlFor="" className="form-label m-0">
															Profile Image
														</label>

														<div className="d-flex flex-wrap gap-10">
															{images?.map((item) => {
																return (
																	<div className="profile_Image  border-2 border">
																		<div className="overlaydocument"></div>

																		<div
																			style={{
																				cursor: "pointer",
																				backgroundColor: "#c11111",
																			}}
																			className="text-white d-flex justify-content-end   "
																		>
																			<div

																				onClick={() => removeImageHandler(item)}
																				className="closeProfile text-white text-center  rounded"
																			>
																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
																					<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
																				</svg>
																			</div>
																		</div>
																		<img
																			src={item}
																			style={{
																				width: "100%",
																				height: "100%",
																			}}
																		/>
																	</div>
																);
															})}
														</div>
														{!images?.length &&
															<div
																className="uploadfile position-relative p-3 rounded bg-light text-center"
																style={{ border: "1px dashed #ddd" }}
															>
																<input
																	type="file"
																	className="file position-absolute opacity-0 h-100 w-100 "
																	style={{ left: 0, top: 0, zIndex: 9 }}
																	accept="image/*"
																	onChange={imageUploadHandler}
																// disabled={imageUploadLoader}
																/>
																<div className="btn text-white d-inline-flex align-items-center justify-content-center commonBtn">
																	{imageUploadLoader ? "Uploading..." : "Browse"}
																</div>
															</div>
														}
													</Col>
													<Col md="12" className="my-2">
														<label htmlFor="businessName" className="form-label m-0">
															Business Name <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="businessName"
															register={register}
															errors={errors}
															name={"businessName"}
															placeholder="Enter Business Name"
														/>
													</Col>
													<Col lg="12" className="my-2">
														<label htmlFor="businessEmail" className="form-label m-0">
															Business Email <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="businessEmail"
															register={register}
															errors={errors}
															name={"businessEmail"}
															placeholder="Enter Business Email"
														/>
													</Col>
													<Col lg="12" className="my-2">
														<label htmlFor="password" className="form-label m-0">
															Password <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="password"
															register={register}
															errors={errors}
															name={"password"}
															placeholder="Enter Password"
														/>
													</Col>
													<Col lg="12" className="my-2">
														<label htmlFor="cnfPassword" className="form-label m-0">
															Confirm Password <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="cnfPassword"
															register={register}
															errors={errors}
															name={"cnfPassword"}
															placeholder="Enter Confirm Password"
														/>
													</Col>
													<Col md="12" className="my-2">
														<label htmlFor="mobileNumber" className="form-label m-0">
															Mobile Number <span className="asterisk">*</span>
														</label>
														<PhoneInput
															id="mobileNumber"
															value={watch("mobileNumber")}
															onChange={(data, { dialCode }) => {
																setValue("mobileNumber", data, {
																	shouldValidate: true,
																});
																setValue("countryCode", dialCode, {
																	shouldValidate: true,
																});
															}}
															country={"us"} // Default country
															placeholder="Enter Mobile Number"
														/>
														{errors.mobileNumber && (
															<p className="text-danger">
																{errors.mobileNumber.message}
															</p>
														)}
													</Col>
													<Col md="12" className="my-2">
														<label htmlFor="" className="form-label m-0">
															Store Location <span className="asterisk">*</span>
														</label>
														<AddressInput
															name="storeLocation"
															placeholder="Store Location"
															errorLabel="Address"
															required
															defaultValue=""
															onLatLongGet={onLatLongGet}
															setValue={(val) =>
																setValue("storeLocation", val, { shouldValidate: true })
															}
															trigger={() => trigger("storeLocation")}
															value={watch("storeLocation")}
														/>
														{
															<p className="errorColor">
																{(errors?.storeLocation && errors?.storeLocation?.message) ||
																	(errors?.storeLocationCoordinates &&
																		errors?.storeLocationCoordinates?.message)}
															</p>
														}
													</Col>
													<Col md="6" className="my-2">
														<label htmlFor="city" className="form-label m-0">
															City <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="city"
															register={register}
															errors={errors}
															name={"city"}
															placeholder="Enter City"
														/>
													</Col>
													<Col md="6" className="my-2">
														<label htmlFor="state" className="form-label m-0">
															State / Province <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="state"
															register={register}
															errors={errors}
															name={"state"}
															placeholder="Enter State / Province"
														/>
													</Col>
													<Col md="6" className="my-2">
														<label htmlFor="pincode" className="form-label m-0">
															Postal / ZIP Code <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="pincode"
															register={register}
															errors={errors}
															name={"pincode"}
															placeholder="Enter Postal / ZIP Code"
														/>
													</Col>
													<Col md="6" className="my-2">
														<label htmlFor="country" className="form-label m-0">
															Country <span className="asterisk">*</span>
														</label>
														<CommonInput
															id="country"
															register={register}
															errors={errors}
															name={"country"}
															placeholder="Enter Country"
														/>
													</Col>
													<Col md="12" className="my-2">
														<label htmlFor="" className="form-label m-0">
															Document Proof
														</label>

														<div className="d-flex flex-wrap gap-10">
															{documents?.map((item) => {
																return (
																	<div className="document_proof w-100 border-2 border ">
																		<div
																			style={{
																				cursor: "pointer",
																				backgroundColor: "#c11111",
																			}}
																			className="text-white d-flex justify-content-end"
																		>
																			<div className="overlaydocument"></div>
																			<div
																				onClick={() => removeDocumentHandler(item)}
																				className="closeProfile text-white text-center  rounded"
																			>
																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
																					<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
																				</svg>
																			</div>
																		</div>
																		<img
																			src={item}
																			style={{
																				width: "100%",
																				height: "100%",
																			}}
																		/>
																	</div>
																);
															})}
														</div>
														{!documents?.length &&
															<div
																className="uploadfile position-relative p-3 rounded bg-light text-center"
																style={{ border: "1px dashed #ddd" }}
															>
																<input
																	type="file"
																	className="file position-absolute opacity-0 h-100 w-100 "
																	style={{ left: 0, top: 0, zIndex: 9 }}
																	accept="image/*"
																	onChange={documentUploadHandler}
																// disabled={documentUploadLoader}
																/>
																<div className="btn text-white d-inline-flex align-items-center justify-content-center commonBtn">
																	{documentUploadLoader ? "Uploading..." : "Browse"}
																</div>
															</div>
														}
													</Col>
													<Col md="12" className="my-2">
														<div className="d-flex align-items-center justify-content-between">

															<label htmlFor="customerName" className="form-label m-0">
																Bank Account Details <span className="asterisk">*</span>
															</label>

															{/* <Button className="commonBtn conenctBtn">Connect</Button> */}
															<label class="switch-stripe">
																<input type="checkbox" checked={isStripeConnected || stripeConnectToggle} onChange={(e) => {
																	handleStripeConnect(e);
																}} />
																<span class="slider round"></span>
															</label>
														</div>
													</Col>

													<Col md="12" className="my-2">



														<div className="method_details">
															<ul>
																<li>
																	<p>Account Number : </p>
																	<p>{stripeAccountDetail?.external_accounts?.data?.[0]?.last4 && isStripeConnected
																		? `xxxx xxxx xxxx ${stripeAccountDetail.external_accounts.data[0].last4}`
																		: '--'}</p>
																</li>
																<li>
																	<p>Routing Number : </p>
																	<p>{stripeAccountDetail?.external_accounts?.data?.[0]?.routing_number && isStripeConnected
																		? `${stripeAccountDetail.external_accounts.data[0].routing_number}`
																		: '--'}</p>
																</li>

																<li>
																	<p>Account Holder Name : </p>
																	<p>{isStripeConnected
																		? `${stripeAccountDetail?.individual?.first_name} ${stripeAccountDetail?.individual?.last_name}`
																		: '--'}</p>
																</li>

																<li>
																	<p>Bank Name :</p>
																	<p>{isStripeConnected ? stripeAccountDetail?.external_accounts?.data?.[0]?.bank_name : '--'}</p>
																</li>
																{isStripeConnected &&
																	<li>
																		<p>Status :</p>
																		<p className="StatusGreen">Connected</p>
																	</li>
																}
															</ul>

														</div>

													</Col>

													<Col lg="12" className="my-2">
														<Button
															type="submit"
															className="btn d-flex align-items-center justify-content-center commonBtn w-100"
															disabled={!isStripeConnected}
														>
															Signup
														</Button>
													</Col>
												</Row>
											</Form>
										</div>
									</Col>
								</Row>
							</div>
						</Col>
					</Row>
				</Container>
			</section >
			<Modal
				show={showModal}
				onHide={handleClose}
				size="md"
				centered
				className="vendorSignup"
			>
				<div className="rounded-5 overflow-hidden" style={{ background: "linear-gradient(324.93deg, #C11111 0.74%, #6F1010 100%)" }}>

					<Modal.Body >

						<div className="text-center">
							<div className="vendorSignup_logo mb-3">
								<img src={logo} alt="" />
							</div>
							<h6 className="text-white px-5">

								Your account has been created successfully. Please wait for approval

							</h6>

							<Button className="modalClose mt-4" onClick={handleClose}>
								Ok
							</Button>

						</div>
					</Modal.Body>
				</div>
			</Modal>
		</>
	)
}

export default VendorSignup;